import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../redux/features/authSlice";
import themeReducer from './features/themeSlice';
import { loginApi } from "./features/loginApi";
import { routeQuestionApi } from "./features/routeQuestionApi";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [routeQuestionApi.reducerPath]: routeQuestionApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      loginApi.middleware,
      routeQuestionApi.middleware,
    ),
});

export default store;
